import { withStyles } from "@material-ui/core/styles";
import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { withTranslation } from "react-i18next";
import { withSnackbar } from "notistack";
import { connect } from "react-redux";
import { setApplicationProperties } from "../../redux/actions/universalActions";
import FormHelperText from "@material-ui/core/FormHelperText";
import { Trans } from "react-i18next";
import ActionButton from "../../components/ActionButton";
import { taxServiceClient } from "../../AxiosClient";

const styles = (theme) => ({
  profilePage: {
    display: "flex",
    justifyContent: "center",
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
  header: {
    marginBottom: 15,
    display: "flex",
  },
});

export class PasswordPage extends Component {
  constructor() {
    super();
    this.state = {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      passwordsDontMatch: false,
      passwordRegexError: false,
      passwordRegex: "",
      passwordRegexErrorMessage: "",
      regEx: "",
      passwordError: false,
      confirmPasswordError: false,
      saveButtonDisabled: false,
      saving: false,
    };
  }

  componentDidMount() {
    this.buildRegexForOrganisation();
    this.buildPasswordErrorMessageForOrganisation();
  }

  render() {
    const { classes, t } = this.props;
    return (
      <>
        <div className={classes.header}>
          <Typography variant="h5" style={{ marginRight: 10 }}>
            {t("user_settings_password_header")}
          </Typography>
          <ActionButton
            variant="contained"
            color="primary"
            onClick={this.changePassword}
            loading={this.state.saving}
            disabled={this.state.saveButtonDisabled}
          >
            {t("global_save")}
          </ActionButton>
        </div>
        <div className={classes.content}>
          <TextField
            required
            label={t("current_password")}
            type="password"
            value={this.state.currentPassword}
            onChange={this.handleCurrentPasswordChange}
          />

          <TextField
            required
            error={
              this.state.confirmPasswordError || this.state.passwordsDontMatch
            }
            label={t("new_password")}
            type="password"
            value={this.state.newPassword}
            onChange={this.handlePasswordChange}
          />
          {this.state.passwordRegexError && (
            <FormHelperText error id="component-error-text">
              {this.state.passwordRegexErrorMessage}
            </FormHelperText>
          )}
          <TextField
            required
            error={
              this.state.confirmPasswordError || this.state.passwordsDontMatch
            }
            label={t("confirm_new_password")}
            type="password"
            value={this.state.confirmPassword}
            onChange={this.handleConfirmPasswordChange}
          />
          {this.state.passwordsDontMatch && (
            <FormHelperText error id="component-error-text">
              <Trans i18nKey="passwords_must_match" />
            </FormHelperText>
          )}
        </div>
      </>
    );
  }

  changePassword = () => {
    this.setState({ saving: true });
    taxServiceClient
      .patch(`/user/password/${this.props.currentUser.userId}`, {
        userId: this.props.currentUser.userId,
        currentPassword: this.state.currentPassword,
        newPassword: this.state.newPassword,
        confirmNewPassword: this.state.confirmPassword,
      })
      .then(() => {
        this.props.enqueueSnackbar(
          this.props.t("password_updated_successfully"),
          {
            variant: "success",
          }
        );
        this.setState({
          saving: false,
        });
      })
      .catch((err) => {
        this.props.enqueueSnackbar(
          this.props.t("error_updating_password") + err.response.data.message,
          {
            variant: "error",
          }
        );
        this.setState({ saving: false });
      });
  };

  handleCurrentPasswordChange = (e) => {
    this.setState({ currentPassword: e.target.value });
  };

  checkPasswordsMatch = () => {
    this.state.newPassword === this.state.confirmPassword
      ? this.setState({ passwordsDontMatch: false }, () => {
          this.checkRequiredFieldsAreFilled();
        })
      : this.setState({ passwordsDontMatch: true }, () => {
          this.checkRequiredFieldsAreFilled();
        });
  };

  checkRequiredFieldsAreFilled = () => {
    if (
      !this.state.passwordError &&
      !this.state.confirmPasswordError &&
      !this.state.passwordsDontMatch &&
      !this.state.passwordRegexError
    ) {
      this.setState({ saveButtonDisabled: false });
    } else {
      this.setState({ saveButtonDisabled: true });
    }
  };

  buildRegexForOrganisation = () => {
    let regExString = "^(?=.*[a-zA-Z])";
    let passwordStrengthRequirements = JSON.parse(
      this.props.applicationProperties[
        "administration.useradmin.passwordstrengthrequirements"
      ]
    );
    if (passwordStrengthRequirements.useCapitals) {
      regExString += "(?=.*[A-Z])";
    }
    if (passwordStrengthRequirements.useNumbers) {
      regExString += "(?=.*\\d)";
    }
    if (passwordStrengthRequirements.useSpecialCharacters) {
      regExString += "(?=.*[@$!%*?&^.()])";
    }
    if (passwordStrengthRequirements.minimumCharacters != null) {
      regExString +=
        "[A-Za-z\\d@$!%*?&^.()]{" +
        passwordStrengthRequirements.minimumCharacters +
        ",}$";
    }
    this.setState({ regEx: regExString });
  };

  buildPasswordErrorMessageForOrganisation = () => {
    let passwordErrorMessage = "Your password must have a minimum of ";

    let passwordStrengthRequirements = JSON.parse(
      this.props.applicationProperties[
        "administration.useradmin.passwordstrengthrequirements"
      ]
    );

    if (passwordStrengthRequirements.minimumCharacters != null) {
      passwordErrorMessage +=
        passwordStrengthRequirements.minimumCharacters + " characters, ";
    }
    if (passwordStrengthRequirements.useCapitals) {
      passwordErrorMessage += "one capital letter, ";
    }
    if (passwordStrengthRequirements.useNumbers) {
      passwordErrorMessage += "one number ";
    }
    if (passwordStrengthRequirements.useSpecialCharacters) {
      passwordErrorMessage += " and one special character i.e. @$!%*?&^.()";
    }
    this.setState({ passwordRegexErrorMessage: passwordErrorMessage });
  };

  handlePasswordChange = (e) => {
    let passwordRegularExpression = new RegExp(this.state.regEx);

    passwordRegularExpression.test(e.target.value)
      ? e.target.value === ""
        ? this.setState(
            {
              passwordError: true,
              newPassword: e.target.value,
              passwordRegexError: false,
            },
            () => {
              this.checkRequiredFieldsAreFilled();
              this.checkPasswordsMatch();
            }
          )
        : this.setState(
            {
              passwordError: false,
              newPassword: e.target.value,
              passwordRegexError: false,
            },
            () => {
              this.checkRequiredFieldsAreFilled();
              this.checkPasswordsMatch();
            }
          )
      : this.setState(
          { passwordRegexError: true, newPassword: e.target.value },
          () => {
            this.checkPasswordsMatch();
          }
        );
  };

  handleConfirmPasswordChange = (e) => {
    this.state.newPassword === e.target.value
      ? e.target.value === ""
        ? this.setState(
            {
              confirmPasswordError: true,
              confirmPassword: e.target.value,
              passwordsDontMatch: false,
            },
            () => {
              this.checkRequiredFieldsAreFilled();
            }
          )
        : this.setState(
            {
              confirmPasswordError: false,
              confirmPassword: e.target.value,
              passwordsDontMatch: false,
            },
            () => {
              this.checkRequiredFieldsAreFilled();
            }
          )
      : this.setState(
          {
            passwordsDontMatch: true,
            confirmPassword: e.target.value,
          },
          () => {
            this.checkRequiredFieldsAreFilled();
          }
        );
  };
}

const mapStateToProps = (state) => ({
  applicationProperties: state.setting.applicationProperties,
});

const mapDispatchToProps = {
  setApplicationProperties,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(withSnackbar(PasswordPage))));
